import { useTranslation } from "react-i18next";
import { Box, IconButton, Modal, Typography } from "@mui/material";

import { CloseIcon } from "../../../assets/icons/MUI/UIComponentsIcons";

import ServiceRequestSubmittedFigure from "../assets/images/request-successful-figure.png";

const RequestSubmittedModal = ({ open, closeModal }: { open: boolean; closeModal: () => void }) => {
  const { t } = useTranslation("goService", { keyPrefix: "requestSubmittedModal" });

  return (
    <Modal open={open} onClose={closeModal}>
      <Box
        sx={{
          width: "800px",
          height: "fit-content",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          borderRadius: "16px",
          background: "#FFF",
          boxShadow: "0px 4px 50px 0px rgba(0, 0, 0, 0.08), 0px 4px 6px 0px rgba(0, 0, 0, 0.05)",
        }}
      >
        <IconButton onClick={closeModal} sx={{ position: "absolute", top: "16px", right: "16px" }} size="small">
          <CloseIcon />
        </IconButton>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "32px", padding: "32px" }}>
          <Box
            component="img"
            src={ServiceRequestSubmittedFigure}
            alt="service-request-submitted"
            sx={{
              width: "210px",
              height: "160px",
            }}
          />
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
            <Typography
              sx={{
                color: "#000",
                textAlign: "center",
                fontFamily: "Montserrat",
                fontSize: "32px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "normal",
              }}
            >
              {t("title")}
            </Typography>
            <Typography
              sx={{
                color: "var(--Gray-Gray-700, #5E6278)",
                textAlign: "center",
                fontFamily: "Montserrat",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "150%",
              }}
            >
              {t("description")}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default RequestSubmittedModal;
